<template>
  <div class="event-schedule-item">

    <b-container>


      <b-row>
        <b-col cols="12" lg="8">
          <div class="events-panel">
            <div class="events-header">
              <h2 class="events-heading mb-0">
                <b-icon icon="calendar-event" class="mr-2"></b-icon>Permanences à venir
              </h2>
            </div>

            <p v-if="!upcomingEvents.length" class="text-muted mb-0 px-3 py-3">
              Aucune ouverture n'est programmée pour le moment.
            </p>

            <b-table-simple v-else responsive class="event-table">
            <b-tbody>

              <b-tr v-for="event in upcomingEvents" :key="event.id" class="">

                <template v-if="event.openingType === 'MEMBER_OPENING'">
                  <b-th class="date-column">
                    <div class="event-date text-center">
                      <div class="day-name">{{ event.day }}</div>
                      <div class="day-number">{{ event.dayDigit }}</div>
                      <div class="month">{{ event.month }}</div>
                    </div>
                  </b-th>

                  <b-td class="event-details align-middle">

                    <div class="event-wrap">
                      <div class="event-header-row d-flex flex-wrap align-items-start">
                        <h4 class="event-title mb-1">
                          <b-link href="#" @click.prevent="handleTitleClick(event)">{{ event.title }}</b-link>
                        </h4>
                      </div>

                      <div class="event-times mb-2 text-muted font-weight-bold">
                        <b-icon icon="clock" class="mr-1"></b-icon>
                        {{ getOpeningsTimes(event) }}
                      </div>

                      <div class="event-description-row d-flex flex-wrap align-items-start justify-content-between">
                        <!-- <p v-if="event.description" class="event-description mb-0 text-muted">
                          {{ event.description }}
                        </p> -->
                        <div class="counters d-flex">
                          <b-badge
                            variant="primary"
                            pill
                            class="d-flex align-items-center"
                            title="Nombre de participants"
                          >
                            <b-icon icon="people-fill"></b-icon>
                            <span class="ml-1">{{ event.attendees }} </span>
                          </b-badge>
                          <b-badge
                            variant="success"
                            pill
                            class="d-flex align-items-center"
                            title="Nombre de covoiturages"
                          >
                            <b-icon icon="car-front" class="mr-1"></b-icon>
                            <span class="ml-1">{{ event.carpoolers }} </span>
                          </b-badge>
                        </div>
                      </div>
                    </div>
                  </b-td>


                  <b-td class="action-column text-right align-middle">
                    <b-button v-if="event.isRegistered"
                      variant="link"
                      class="register-btn p-0"
                      :disabled="true"
                    >
                      <b-icon icon="check" variant="success" font-scale="4"></b-icon>
                    </b-button>

                    <b-button v-else-if="event.isPreregistered" 
                      variant="link"
                      class="register-btn p-0"
                      title="Préinscrit — en attente de validation par l'ouvreur"
                      @click="$router.push({ name: 'my-registrations' })"
                    >
                      <b-icon icon="check" variant="success" font-scale="4"></b-icon>
                    </b-button>

                    <b-button v-else
                      variant="link"
                      class="register-btn p-0"
                      :disabled="event.hasPassed"
                      @click="EventRegistrationClick(event)"
                    >
                      <b-icon icon="chevron-right" variant="primary" font-scale="4"></b-icon>
                    </b-button>
                  </b-td>
                </template>

                <template v-else-if="event.openingType === 'DAY_BLOCKED'" >
                  <b-th class="date-column">
                    <div class="event-date text-center">
                      <div class="day-name">{{ event.day }}</div>
                      <div class="day-number">{{ event.dayDigit }}</div>
                      <div class="month">{{ event.month }}</div>
                    </div>
                  </b-th>

                  <b-td class="event-details align-middle">

                      <h5 class="event-title mb-1">
                        <b-link href="#">{{ event.title }}</b-link>
                      </h5>
                      <p v-if="event.description" class="event-description mb-0 text-muted">
                        {{ stripHtml(event.description) }}
                      </p>
                  </b-td>


                  <b-td class="action-column text-right align-middle">
                    <b-button 
                      variant="link" 
                      class="register-btn p-0"
                      disabled
                    >
                      <b-icon variant="danger" icon="x" font-scale="4"></b-icon>
                    </b-button>

                  </b-td>                 
                </template>

                <template v-else-if="event.openingType === 'ADMIN_EVENT'" >
                  <b-th class="date-column">
                    <div class="event-date text-center">
                      <div class="day-name">{{ event.day }}</div>
                      <div class="day-number">{{ event.dayDigit }}</div>
                      <div class="month">{{ event.month }}</div>
                    </div>
                  </b-th>

                  <b-td class="event-details align-middle">

                      <h5 class="event-title mb-1">
                        <b-link href="#" @click.prevent="EventRegistrationClick(event)"><b-icon icon="patch-check-fill" title="événement officiel" variant="success"></b-icon> {{ event.title }} </b-link>
                      </h5>

                      <div class="organizers mr-3">
                        <b-link href="#" class="text-muted">
                          <b-icon icon="person" class="mr-1"></b-icon>
                             {{ availablePlacesLabel(event) }}
                        </b-link>
                      </div>

                      <div class="price">
                        <span class="text-primary font-weight-bold">
                          <b-icon icon="tag-fill" class="mr-1"></b-icon>
                          {{event.price }}
                        </span>
                      </div>

                  </b-td>
                  


                  <b-td class="action-column text-right align-middle">
                    <b-button
                      variant="link" 
                      class="register-btn p-0"
                      :disabled="event.hasPassed"
                      @click="EventRegistrationClick(event)"
                    >
                      <b-icon icon="chevron-right" variant="primary" font-scale="4"></b-icon>
                    </b-button>


                  </b-td> 
                </template>
                
                
              </b-tr>
            </b-tbody>
          </b-table-simple>
          </div>

          <div v-if="pastEventsVisible.length" class="events-panel mt-5">
            <div class="events-header">
              <h3 class="events-heading mb-0">
                <b-icon icon="clock-history" class="mr-2"></b-icon>Permanences passées
              </h3>
            </div>
          <b-table-simple responsive class="event-table">
            <b-tbody>
              <b-tr v-for="event in pastEventsVisible" :key="event.id" class="">

                <template v-if="event.openingType === 'ADMIN_EVENT'">
                  <b-th class="date-column">
                    <div class="event-date text-center">
                      <div class="day-name">{{ event.day }}</div>
                      <div class="day-number">{{ event.dayDigit }}</div>
                      <div class="month">{{ event.month }}</div>
                    </div>
                  </b-th>
                  <b-td class="event-details align-middle"> 
                    <h5 class="event-title mb-1 text-muted">
                      <b-icon icon="patch-check-fill" title="événement officiel"></b-icon>
                      {{ event.title }}
                    </h5>
                    <div class="organizers mr-3 text-muted">
                      <b-icon icon="person" class="mr-1"></b-icon>
                      évènement terminé
                    </div>
                    <div class="price text-muted">
                      <span class="font-weight-bold">
                        <b-icon icon="tag-fill" class="mr-1"></b-icon>
                        {{ event.price }}
                      </span>
                    </div>
                  </b-td>
                  <b-td class="action-column text-right align-middle">
                    <b-button
                      variant="link"
                      class="register-btn p-0"
                      disabled
                      style="visibility: hidden"
                    >
                      <b-icon icon="chevron-right" variant="primary" font-scale="4"></b-icon>
                    </b-button>
                  </b-td>
                </template>

                <template v-else>
                  <b-th class="date-column">
                    <div class="event-date text-center">
                      <div class="day-name">{{ event.day }}</div>
                      <div class="day-number">{{ event.dayDigit }}</div>
                      <div class="month">{{ event.month }}</div>
                    </div>
                  </b-th>
                  <b-td class="event-details align-middle">
                    <div class="event-wrap">
                      <div class="event-header-row d-flex flex-wrap align-items-start">
                        <h5 class="event-title mb-1 text-muted">
                          {{ event.title }}
                        </h5>
                      </div>
                      <div class="event-times mb-2">
                        <span class="text-muted font-weight-bold">
                          <b-icon icon="clock" class="mr-2"></b-icon>
                          {{ getOpeningsTimes(event) }}
                        </span>
                      </div>
                      <div class="event-description-row d-flex flex-wrap align-items-start justify-content-between">
                        <!-- <p v-if="event.description" class="event-description mb-0 text-muted">
                          {{ event.description }}
                        </p> -->
                        <div class="counters d-flex">
                          <b-badge
                            variant="secondary"
                            pill
                            class="d-flex align-items-center mr-2"
                            title="Nombre de participants"
                          >
                            <b-icon icon="people-fill"></b-icon>
                            <span class="ml-1">{{ event.attendees }} </span>
                          </b-badge>
                          <b-badge
                            variant="secondary"
                            pill
                            class="d-flex align-items-center"
                            title="Nombre de covoiturages"
                          >
                            <b-icon icon="car-front" class="mr-1"></b-icon>
                            <span class="ml-1">{{ event.carpoolers }} </span>
                          </b-badge>
                        </div>
                      </div>
                    </div>
                  </b-td>
                  <b-td class="action-column text-right align-middle">
                    <b-button
                      variant="link"
                      class="register-btn p-0"
                      disabled
                      style="visibility: hidden"
                    >
                      <b-icon icon="chevron-right" variant="primary" font-scale="4"></b-icon>
                    </b-button>
                  </b-td>
                </template>

              </b-tr>
            </b-tbody>
          </b-table-simple>
          </div>
        </b-col>

        <b-col cols="12" lg="4" class="mt-5 mt-lg-0">
          <NewsPanel />
        </b-col>
      </b-row>
    </b-container>

    <EventRegistrationModal
      :event="selectedEvent"
      :visible="modalVisible"
      :user-has-valid-adhesion="userHasValidAdhesion"
      @update:visible="modalVisible = $event"
      @register="handleRegistration"
      @join-carpool="handleJoinCarpool"
    />

    <!--
    <AddOpeningModal
      :visible="addOpeningVisible"
      @update:visible="addOpeningVisible = $event"
      @submit-opening="handleNewOpening"
    />
    -->
  </div>
</template>


<script>
import EventRegistrationModal from '@/components/EventRegistrationModal.vue';
import NewsPanel from '@/components/NewsPanel.vue';
import session from "@/store/session";
import OpeningService from '@/services/opening.service';
import AdhesionService from '@/services/adhesion.service';

export default {
  name: 'Home',
  components: {
    EventRegistrationModal,
    NewsPanel,
  },
  data() {
    return {
      events: [],
      addOpeningVisible: false,
      modalVisible: false,
      selectedEvent: {},
      user: null,
      userHasValidAdhesion: false,
    }
  },
  async mounted() {
    await this.fetchOpenings();
    this.user = session.user;
    await this.checkUserAdhesion();
    this.handleOpenOpening();
  },
  methods: {
    async fetchOpenings() {
      try {
        const res  = await OpeningService.list(); 
        const data = res.data;
        console.log("Openings fetched:", data);
        if (res.status === 200 && data && !data.error) {
          this.events = data.map(opening => {
            const now = new Date();
            const defaultDate = new Date(opening.date || 0);
            defaultDate.setHours(23, 59, 59, 999);
            const getSafeDate = (value, fallback = defaultDate) => {
              const parsed = new Date(value);
              return Number.isNaN(parsed.getTime()) ? fallback : parsed;
            };
            const sortedOpeningEvents = Array.isArray(opening.openingEvents)
              ? [...opening.openingEvents].sort((a, b) => getSafeDate(a.time) - getSafeDate(b.time))
              : [];
            const firstEventTime = sortedOpeningEvents[0] && sortedOpeningEvents[0].time
              ? getSafeDate(sortedOpeningEvents[0].time)
              : defaultDate;
            const lastEvent = sortedOpeningEvents.length ? sortedOpeningEvents[sortedOpeningEvents.length - 1] : null;
            const lastEventTime = lastEvent && lastEvent.time
              ? getSafeDate(lastEvent.time)
              : firstEventTime;
            return {
              id: opening.id,
              openingType: opening.openingType,
              title: opening.title || 'Ouverture du club',
              description: opening.description,
              organizer: opening.owners,
              openingEvents: sortedOpeningEvents, // data.events is an array of event related to the opening
              openingDate: opening.date, // is the date of the opening which correspond to the nearest event date
              month: firstEventTime.toLocaleString('fr-FR', { month: 'short' }),
              day: firstEventTime.toLocaleString('fr-FR', { weekday: 'short' }),
              dayDigit: firstEventTime.getDate(),
              attendees: parseInt(opening.participantsCount) + parseInt(opening.preregistrationsCount || 0),
              carpoolers: Array.isArray(opening.covoits) ? opening.covoits.length : 0,
              price: opening.price ? `${opening.price} €` : 'Gratuit',
              placesNbr: opening.placesNbr,
              hasPassed: lastEventTime < now,
              isRegistered: opening.isRegistered || false,
              isPreregistered: opening.isPreregistered || false,
            };
          });
        } else {
          console.error("Erreur lors de la récupération des ouvertures :", data.error);
        }
      }
      catch (error) {
        console.error("Erreur lors de la récupération des ouvertures :", error);
      }
    },
    async checkUserAdhesion() {
  
      try {
        const response = await AdhesionService.checkUserAdhesion();  
        this.userHasValidAdhesion = response.data.hasAdhesion;
      } catch (error) {
        console.error("Erreur lors de la vérification de l'adhésion :", error);
        this.userHasValidAdhesion = false;
      }
    },
    handleOpenOpening() {
      const openingId = this.$route.query.openOpening;
      if (!openingId) return;
      const event = this.events.find(e => e.id === openingId);
      if (event) {
        this.$router.replace({ query: {} });
        this.EventRegistrationClick(event);
      }
    },
    handleTitleClick(event) {
      if (event.isRegistered || event.isPreregistered) {
        this.$router.push({ name: 'my-registrations' });
        return;
      }
      this.EventRegistrationClick(event);
    },
    EventRegistrationClick(event) {
      if (event.openingType !== 'ADMIN_EVENT' && !this.isLogged) {
        this.$bvToast.toast('Vous devez être connecté pour vous inscrire à une ouverture.', {
          title: 'Attention',
          variant: 'warning',
          solid: true
        });
        return;
      }
      this.selectedEvent = event;
      this.modalVisible = true;
    },
    handleRegistration(event) {
      this.$bvToast.toast('Registration successful!', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },
    getOpeningsTimes(event) {
      const events = event && Array.isArray(event.openingEvents) ? event.openingEvents : [];
      if (!events.length) return "Horaire à définir";
      const firstEvent = events[0];
      const firstEventTime = this.formatOpeningEventTime(firstEvent.time);
      const firstEventType = this.formatOpeningEventType(firstEvent.type);
      return `Première heure : ${firstEventTime} (${firstEventType})`;
    },
    stripHtml(value) {
      if (!value) return "";
      const doc = new DOMParser().parseFromString(String(value), "text/html");
      return (doc.body.textContent || "").trim();
    },
    formatOpeningEventType(type) {
      if (type === "ouverture") return "ouverture";
      if (type === "fermeture") return "fermeture";
      return "événement";
    },
    formatOpeningEventTime(time) {
      if (!time) return "??:??";
      const date = new Date(time);
      if (Number.isNaN(date.getTime())) return "??:??";
      return date.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Europe/Paris",
      });
    },
    handleJoinCarpool(event) {
      this.$bvToast.toast('Joined carpool successfully!', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },
    availablePlacesCount(event) {
      return Number(event.placesNbr) - Number(event.attendees);
    },
    availablePlacesLabel(event) {
      if(event.placesNbr == 0) return 'Nombre de place illimité'
      const available = this.availablePlacesCount(event);
      return available > 0 ? `${available} places disponibles` : 'Complet';
    },
    getEventDate(event) {
      if (!event) return new Date(0);
      const eventTime =
        event.openingEvents && event.openingEvents.length
          ? event.openingEvents[0].time
          : event.openingDate;
      return eventTime ? new Date(eventTime) : new Date(0);
    },
  },
  computed: {
    upcomingEvents() {
      return this.events
        .filter(event => !event.hasPassed)
        .sort((a, b) => this.getEventDate(a) - this.getEventDate(b));
    },
    pastEvents() {
      return this.events
        .filter(event => event.hasPassed)
        .sort((a, b) => this.getEventDate(b) - this.getEventDate(a));
    },
    pastEventsVisible() {
      return this.pastEvents.filter(event => event.openingType !== 'DAY_BLOCKED').slice(0, 2);
    },
    isLogged() {
      return session.isLoggedIn();
    },
    isOuvreur() {
      return session.user.role === "ouvreur";
    },
  }
}
</script>

<style scoped>
.event-schedule-item {
  padding: 20px 0;
}

/* --- Panneaux Permanences (même langage visuel que le panneau Actualités) --- */
.events-panel {
  background: #f4f8fa;
  border: 1px solid var(--color-stroke-soft, #b8dde4);
  border-radius: 12px;
  overflow: hidden;
}

.events-header {
  padding: 14px 18px 12px;
  background: var(--color-guc-darkblue, #056d80);
}

.events-heading {
  font-family: 'Gagalin', sans-serif;
  font-size: 1.15rem;
  color: #ffffff;
  display: flex;
  align-items: center;
}

.event-table {
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 0;
}

/* theme.css force un fond bleu clair sur table/.table : on laisse voir
   le fond du panneau pour matcher la carte Actualités */
.events-panel >>> table,
.events-panel >>> .table {
  background-color: transparent !important;
  margin-bottom: 0;
}

.event-table >>> th,
.event-table >>> td {
  border-top: none;
}

.event-table >>> tbody tr + tr th,
.event-table >>> tbody tr + tr td {
  /* !important pour passer devant le border-color !important de theme.css */
  border-top: 1px solid var(--color-border-light, #e6eaee) !important;
}

.event-table >>> tbody tr {
  vertical-align: middle;
  transition: background 0.15s;
}

.event-table >>> tbody tr:hover {
  background: #e9f2f5;
}

/* .event-table >>> tbody tr:hover .date-column {
  box-shadow: inset 3px 0 0 var(--color-guc-yellow, #ff914d);
} */

.event-table >>> .date-column {
  padding-right: 0 !important;
  padding-left: 0.5rem !important;
}

.event-table >>> .event-details {
  padding-left: 0.5rem !important;
}

.event-date {
  min-width: 50px;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.day-name {
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.day-number {
  font-size: 26px;
  font-weight: 700;
  color: #343a40;
  line-height: 1;
  margin: 2px 0;
}

.month {
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 2px;
}

.event-title,
.event-title a {
  font-family: 'Gagalin', sans-serif;
  font-size: 1.15rem;
}

.event-title a {
  color: #343a40;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-description {
  font-size: 14px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-title a:hover {
  color: #007bff;
}

.time {
  font-size: 15px;
}

.event-header-row {
  gap: 0.5rem;
}

.event-times {
  font-size: 14px;
  line-height: 1.4;
}

.event-description-row {
  gap: 0.75rem;
}

.event-description-row .event-description {
  flex: 1;
  min-width: 220px;
}

.meta {
  font-size: 14px;
}

.register-btn {
  color: #007bff;
  transition: transform 0.2s;
}

.register-btn:hover {
  transform: translateX(3px);
  text-decoration: none;
}

.counters {
  gap: 8px;
}

/* Empêche le scroll horizontal sur mobile causé par Bootstrap .table-responsive */
.event-schedule-item >>> .table-responsive {
  overflow-x: visible;
}

@media (max-width: 768px) {
  .event-date {
    min-width: 50px;
  }

  .day-number {
    font-size: 20px;
  }

  .day-name,
  .month {
    font-size: 10px;
  }

  .event-title a {
    font-size: 14px;
  }

  .event-times,
  .event-description {
    font-size: 12px;
  }

  .event-header-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .counters {
    margin-top: 5px;
  }

  /* Supprime le min-width qui forçait la table à dépasser l'écran */
  .event-description-row .event-description {
    min-width: 0;
  }

  /* Réduit la taille de l'icône chevron pour la colonne action */
  .action-column .b-icon {
    font-size: 2em !important;
  }
}
</style>
